<template>
    <!-- <div class="cgs-app-myprocess-content"> -->
    <van-pull-refresh v-model="loading" @refresh="refresh" class="myprocess-cgsFormList">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText">
            <van-cell v-for="item in list" :key="item.id" :clickable="true" title="标题"
                @click="clickCellHandle(item)" class="cgs-list-row">
                <template #icon>
                    <div class="cgs-list-row-icon-wrap">
                        <van-icon class-prefix="cgsIcon" name="gongzuoliuchengtu"
                            class="iconfont message-workflow-icon" />
                    </div>
                </template>
                <template #title>
                    <div class="todo-list-row-header">
                        <span class="todo-list-automation">{{ showAppTitle(item) }}</span>
                        <van-tag color="#FFC300" class="todo-type-title">处理中</van-tag>
                    </div>
                    <div>{{ showAutomationName(item) }}</div>
                </template>
                <template #label>
                    <div class="todo-list-row-label">
                        <div>{{item.createTime}}</div>
                        <div class="todo-list-row-label-faqiren">
                            <span class="iconfont cgsIcon-wode-F" style="margin-right:2px;"></span>
                            {{item.startBy.username}}
                        </div>
                    </div>
                </template>
            </van-cell>
        </van-list>
        <van-empty v-if="!loading && list.length === 0" description="暂无我发起的事项" />
    </van-pull-refresh>
    <!-- </div> -->
</template>

<script>
import {
    NavBar,
    Tab,
    Tabs,
    PullRefresh,
    Search,
    List,
    Col,
    Row,
    Icon,
    Cell,
    Empty,
    Tag,
    ImagePreview,
} from "vant";
import {
    getFaqiList
} from '@/api/myProcess'

export default {
    components: {
        vanNavBar: NavBar,
        vanTab: Tab,
        vanTabs: Tabs,
        vanSearch: Search,
        vanList: List,
        vanPullRefresh: PullRefresh,
        vanCol: Col,
        vanRow: Row,
        vanIcon: Icon,
        vanCell: Cell,
        vanEmpty: Empty,
        vanTag: Tag
    },
    data() {
        return {
            loading: false,
            finished: false,
            list: []
        }
    },
    created() {
        this.init()
        this.$ws.on("send_notice", async (data) => {
            this.init()
        });
        this.$ws.on("clear_notice", async (data) => {
            this.init()
        });
    },
    computed:{
        finishedText:{
            get(){
                return this.list.length > 0?'没有更多了':''
            },
            set(){}
        }
    },
    methods: {
        async init() {
            this.loading = true
            try {
                let result = await getFaqiList()
                if (result.code === 200) {
                    this.list = result.data === null ? [] : result.data
                }
                this.loading = false
                this.finished = true
            } catch (err) {
                this.loading = false
                this.finished = true
            }
        },
        refresh() {
            this.init()
        },
        clickCellHandle(obj) {
            let id = obj.id;
            this.$router.push(`/processform/${id}/faqi`)
        },
        showAutomationName(item) {
            let _name = '流程不存在'
            if (item?.automation?.name) {
                _name = item.automation.name
            }
            return _name
        },
        showAppTitle(item) {
            let _title = '表单不存在'
            if (item?.app?.title) {
                _title = item.app.title
            }
            return _title
        }
    }
}
</script>

<style scoped>
.cgs-list-row {
    margin-bottom: 10px;
}
.todo-list-row-label{
    display: flex;
    justify-content: space-between;
}
.todo-list-row-label-faqiren{
    flex: 1;
    width: 0;
    margin-left: 10px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.todo-list-row-header .todo-list-automation {
    font-size: 12px;
    color: #969799;
}

.todo-list-row-header .todo-type-title {
    float: right;
}

.cgs-list-row-icon-wrap {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #0078d7;
    text-align: center;
    margin: auto 10px;
}
</style>